import { GlAccount, DEFAULT_GL_ACCOUNT } from "../hooks/useGLAccounts";
import { Subledger } from "../components/specific/SubledgerSelector/SubledgerSelector";

export interface GlAccountSummary {
    id: string;
    icon: string | null;
    label_nl: string;
    cashflow_subcategory_nl: string;
    subledger: Subledger | null;
}

export function subledgerFromApiResponse(data: Record<string, unknown> | null | undefined): Subledger | null {
    if (!data) {
        return null;
    }
    return {
        id: data['id'] as string,
        name: data['name'] as string,
    };
}

export function glAccountSummaryFromApiResponse(
    data: Record<string, unknown> | null | undefined,
    subledgerData?: Record<string, unknown> | null,
): GlAccountSummary {
    if (!data) {
        return glAccountSummaryFromGlAccount(DEFAULT_GL_ACCOUNT);
    }
    return {
        id: data['id'] as string,
        icon: (data['icon'] as string | null) ?? null,
        label_nl: data['label_nl'] as string,
        cashflow_subcategory_nl: data['cashflow_subcategory_nl'] as string,
        subledger: subledgerFromApiResponse(subledgerData),
    };
}

export function glAccountSummaryFromGlAccount(account: GlAccount): GlAccountSummary {
    return {
        id: account.id,
        icon: account.icon,
        label_nl: account.label_nl,
        cashflow_subcategory_nl: account.cashflow_subcategory_nl,
        subledger: null,
    };
}
